import axios from "axios";

export const createSessionApi = async (params) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/genrate-link`,
    params
  );
  return data;
};

export const joinSessionApi = async (params) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/join-session`,
    params
  );
  return data;
};

export const getSessionByIdApi = async (id) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/getSession/${id}`,
    {}
  );
  return data;
};
